import { RateCardTermType, RuleCompareOperator } from '@bringg/types';
import { Condition } from 'features/conditions/rule/rule-utils';
import { cloneDeep } from 'lodash';

import { DRIVING_DISTANCE_RULE_CONDITION_PATH } from '../consts';

export const mapRateCardConditionWithAllowedOperators = (
	condition: Condition,
	termType: RateCardTermType
): Condition => {
	const clonedCondition = cloneDeep(condition);

	if (condition.path === DRIVING_DISTANCE_RULE_CONDITION_PATH) {
		const allowedOperators =
			termType === RateCardTermType.Base
				? [RuleCompareOperator.LESS_THAN_OR_EQUALS]
				: [RuleCompareOperator.GREATER_THAN];

		return { ...clonedCondition, allowedOperators };
	}

	return clonedCondition;
};

export const mapRateCardConditionsWithAllowedOperators = (
	conditions: Condition[],
	termType: RateCardTermType
): Condition[] => {
	return conditions.map(condition => mapRateCardConditionWithAllowedOperators(condition, termType));
};
